import { useEffect } from 'react'
import WebApp from '@twa-dev/sdk' // Adjust the import path if necessary

type UseBackButtonType = {
  onBack?: () => void
  forceHide?: boolean
}

export const useBackButton = ({ onBack, forceHide = false }: UseBackButtonType) => {
  useEffect(() => {
    const handleBackButtonClick = () => {
      WebApp.HapticFeedback.impactOccurred('rigid')
      if (onBack) {
        onBack()
      } else {
        window.history.back()
      }
    }
    WebApp.BackButton.show()
    WebApp.BackButton.onClick(handleBackButtonClick)

    if (forceHide) {
      WebApp.BackButton.offClick(handleBackButtonClick)
      WebApp.BackButton.hide()
    }

    return () => {
      WebApp.BackButton.hide()
      WebApp.BackButton.offClick(handleBackButtonClick)
    }
  }, [onBack, forceHide])
}
